exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dispersion-chart{width:100%;position:relative}.chart-wrapper{height:720px;height:var(--chart-height,720px)}.arrow{background:#979797;height:1px;width:50px;position:relative;display:none}.arrow:after{content:\"\";position:absolute;width:0;height:0;border-style:solid;border-width:4px 0 4px 8px;border-color:transparent transparent transparent #979797;right:-3px;top:-3px}.arrow--right{margin-left:16px}.arrow--top{margin-left:-50px;margin-top:-50%;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}@media screen and (min-width:768px){.arrow{display:block}}", ""]);

// exports
